import { render, staticRenderFns } from "./CardTotalizadores.vue?vue&type=template&id=63066b3c&scoped=true&lang=pug"
import script from "./CardTotalizadores.vue?vue&type=script&lang=js"
export * from "./CardTotalizadores.vue?vue&type=script&lang=js"
import style0 from "./CardTotalizadores.vue?vue&type=style&index=0&id=63066b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63066b3c",
  null
  
)

export default component.exports